<template lang="pug">
  .container.grid-lg.py-2
    .panel
      .panel-header
        .h4.text-primary Novo Documento
        div Tipo: #[b {{ `enums.db.enum_doc_tipo.${$route.params.docTipo}` | translate }}]
        div
          .divider
          steps.pt-2(:steps="steps")
        .divider
      .panel-body.mb-2
        router-view(:steps="steps")
</template>

<script>
import { LocalStorageFacade } from 'paliari-js-utils'
import mapRoutes from './mapRoutes'

export default {
  props: { docTipo: String },
  data() {
    return {
      localStorageSteps: [],
    }
  },
  computed: {
    steps() {
      return this.localStorageSteps
        .map(name =>
          this.mapRoutes[name] ? { ...this.mapRoutes[name], name } : null,
        )
        .filter(route => Boolean(route))
    },
    mapRoutes() {
      return mapRoutes('create')
    },
  },
  created() {
    this.localStorageSteps = LocalStorageFacade.getItem('steps')
  },
  destroyed() {
    LocalStorageFacade.removeItem('steps')
    LocalStorageFacade.removeItem('doc')
  },
}
</script>
